<template>
  <div>
    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6"> <CIcon v-if="icon" :name="icon" class="mr-2"/> {{ caption }} </span>
        <div class="card-header-actions">
          <span class="mr-2">Total : {{ items.length }}</span>
          <CButton
            size="sm"
            color="light"
            variant="outline"
            class="export-icon-button"
            :disabled="loading || !items.length"
            title="Export Excel"
            aria-label="Export Excel"
            v-c-tooltip.hover.click="'Export Excel'"
            @click="exportAll"
          >
            <CIcon name="cil-cloud-download"/>
          </CButton>
        </div>

      </CCardHeader>
      <CCardBody>
        <CDataTable
            :table-filter="{label:$t('search')}"
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            :items="items"
            :fields="fields"
            :items-per-page="small ? 50 : 20"
            :dark="dark"
            pagination
            :loading="loading"
            sorter
        >
          <template #index="{item,index}">
            <td class="text-center"  @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
          </template>

          <template #isTalent="{ item, index}">
            <td class="text-center" > {{ (item.isTalent == true)?$t('gap.found'):$t('gap.notFound') }}</td>
          </template>

          <template #employmentStatus="{ item }">
            <td class="text-center">{{ item.employmentStatus || '-' }}</td>
          </template>

          <template #state="{ item }">
            <td>
              <span
                class="font-weight-bold"
                :class="isColor(item.status)"
              >
                {{ item.state || '-' }}
              </span>
              {{ onCheckState(item) }}
              <br>
              <span
                class="font-weight-bold"
                :class="isColor(item.status)"
              >
                {{ $t('LatestTime') }} :
              </span>
              {{ elapsedTime(item.latestStatusTime) }}
            </td>
          </template>



          <template #action="{item,index}">
            <td style="width: 140px">
              <CRow>
                <CCol class="text-center">
<!--                  <CButton class="mr-1" v-c-tooltip="{content: $t('tooltip.detail') }" size="sm" color="info" shape="pill" variant="outline" @click="toggleDetails(item, index)"  >-->
<!--                    <CIcon name="cil-description"/>-->
<!--                  </CButton>-->
                  <CButton
                    class="mr-1"
                    v-c-tooltip="{content: $t('tooltip.assessment') }"
                    size="sm"
                    color="dark"
                    shape="pill"
                    variant="outline"
                    :disabled="isActionLoading(item)"
                    @click="onChangeAssessment(item, index)"
                  >
                    <CIcon name="cil-people"/>
                  </CButton>
                  <CButton
                    class="mr-1"
                    v-c-tooltip.hover.click="'Remove'"
                    size="sm"
                    color="danger"
                    shape="pill"
                    variant="outline"
                    :disabled="isActionLoading(item)"
                    @click="onRemove(item, index)"
                  >
                    <CIcon name="cil-trash"/>
                  </CButton>

                </CCol>
              </CRow>
            </td>
          </template>


        </CDataTable>
      </CCardBody>
    </CCard>
    <SearchProfile :is-show="isDialog" :is-select-account="true" @update="onDismiss" :object="nodeData" @select-account="changeAssessment"/>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import moment from "moment";
import SearchProfile from "@/projects/components/Dialog/SearchProfile.vue";
import Organization from "@/projects/views/E-Performances/Organization/index.vue";
import * as XLSX from "xlsx";

export default {
  name: 'History_IDP',
  components: {Organization, SearchProfile},
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Banks'
    },

    fields: {
      type: Array,
      default() {
        return [
          {key:"index", label: "#",  _style: 'width:50px; text-align: center'},
          {key:"code", label:"Code", _style: 'width:30px; text-align: center'},
          {key:"accounts", label:"Name"},
          {key:"employmentStatus", label:"สถานภาพการทำงาน", _style: 'width:180px; text-align: center'},
          {key:"assessor", label:"Assessor"},
          // {key:"isTalent", label: "Talent", _style: 'width:120px; text-align: center'},
          {key:"state", label:"Status",_style: 'width:260px; min-width:260px;'},
          {key:"action", label: "#", _style: 'width:110px; text-align: center'}
        ]
      }
    },
    type: {
      type: String,
      default: 'cil-user'
    },
    year: {
      type: Number,
      default: null
    },
    item: {
      type: Array,
      default: undefined
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    loading: Boolean,
  },

  data: function () {
    return {
      isDialog: false,
      collapseDuration: 0,

      nodeData:{
        children:[]
      },

      prepare:{},
      actionLoadingId: null,
      items:[]
    }
  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      this.onLoad();
    },

    onLoad() {

    },

    toggleDetails (item,index) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})

    },
    onDismiss(){
      this.isDialog = false;
    },

    onChangeAssessment(item,index) {
      this.isDialog = true;
      this.prepare = item;
    },

    async changeAssessment(item, index) {
      this.isDialog = false;

      var body = {};
      body._id = this.prepare.id;
      body.assessor = item.value._id;

      this.actionLoadingId = body._id;
      try {
        await this.$store.dispatch("idp/changeAssessor", body)
        this.$emit("reload");
      } finally {
        this.actionLoadingId = null;
      }
    },
    isActionLoading(item) {
      const id = (item || {}).id || (item || {})._id;
      return !!id && this.actionLoadingId === id;
    },
    async onRemove(item,index) {
      const id = (item || {}).id || (item || {})._id;
      if (!id) {
        return;
      }

      const name = item.accounts && item.accounts !== "-" ? item.accounts : item.code || "";
      const message = this.lang === "th"
        ? `ยืนยันการ Remove สถานะ IDP ของ ${name || "รายการนี้"} ?`
        : `Remove IDP status for ${name || "this item"}?`;

      if (typeof window !== "undefined" && !window.confirm(message)) {
        return;
      }

      var body = {
        _id: id,
        source: "report-idp"
      };

      this.actionLoadingId = id;
      try {
        await this.$store.dispatch("idp/remove", body)
        this.items = this.items.filter((entry) => ((entry || {}).id || (entry || {})._id) !== id);
        this.$emit("reload");
      } finally {
        this.actionLoadingId = null;
      }
    },
    resolveLocalizedValue(items) {
      if (!Array.isArray(items) || items.length === 0) {
        return '';
      }

      return (
        (items.find((entry) => entry && entry.key === this.lang) || {}).value ||
        (items[0] || {}).value ||
        ''
      );
    },

    buildPersonName(userinfo) {
      if (!userinfo) {
        return '-';
      }

      return [
        this.resolveLocalizedValue(userinfo.prefix),
        this.resolveLocalizedValue(userinfo.firstName),
        this.resolveLocalizedValue(userinfo.lastName)
      ].filter(Boolean).join(' ') || '-';
    },

    normalizeDisplayName(value) {
      if (!value) {
        return '-';
      }

      if (typeof value === 'string') {
        return value.trim() || '-';
      }

      const account = (value || {}).accounts || {};
      const nestedAccount = account.accounts || {};
      const userinfo =
        value.userinfo ||
        account.userinfo ||
        nestedAccount.userinfo;

      const personName = this.buildPersonName(userinfo);
      if (personName !== '-') {
        return personName;
      }

      return value.name || value.fullName || value.title || '-';
    },

    resolveHistoryAccountName(history) {
      const accountName = this.buildPersonName(((((history || {}).accounts || {}).accounts || {}).userinfo));
      if (accountName !== '-') {
        return accountName;
      }

      return this.normalizeDisplayName((history || {}).yourself || (history || {}).info || (history || {}).accounts);
    },

    resolveHistoryAssessorName(history) {
      const assessorName = this.buildPersonName((((((history || {}).assessor || {}).accounts || {}).accounts || {}).userinfo));
      if (assessorName !== '-') {
        return assessorName;
      }

      return this.normalizeDisplayName((history || {}).assessor || (history || {}).assessor1 || (history || {}).assessor2);
    },

    resolveStateText(state) {
      if (!state) {
        return '-';
      }

      if (Array.isArray(state)) {
        return this.resolveLocalizedValue(state) || '-';
      }

      if (Array.isArray(state.title)) {
        return this.resolveLocalizedValue(state.title) || '-';
      }

      return state.value || state.title || '-';
    },

    createStateFromLocalizedStatus(statusItems) {
      const localizedStatus =
        (statusItems || []).find((entry) => entry && entry.key === this.lang) ||
        (statusItems || [])[0] ||
        {};
      const idSource = localizedStatus._id
        ? localizedStatus
        : ((statusItems || []).find((entry) => entry && entry._id) || {});

      return {
        _id: idSource._id || '',
        title: statusItems
      };
    },

    resolveAssessmentStatusInfo(history) {
      const status = (history || {}).status;

      if (!status || Array.isArray(status) || !(status.yourself || status.assessor1 || status.assessor2)) {
        return null;
      }

      const assessmentCompleteStateId = '654851ece41b7f46025977fa';
      const entries = [
        {
          key: 'yourself',
          status: status.yourself,
          person: this.normalizeDisplayName((history || {}).yourself || (history || {}).info || (history || {}).accounts)
        },
        {
          key: 'assessor1',
          status: status.assessor1,
          person: this.normalizeDisplayName((history || {}).assessor1)
        },
        {
          key: 'assessor2',
          status: status.assessor2,
          person: this.normalizeDisplayName((history || {}).assessor2)
        }
      ].filter((entry) => entry.status);

      const target =
        entries.find((entry) => ((entry.status.state || {})._id || '').toString() !== assessmentCompleteStateId) ||
        entries.at(-1);

      if (!target) {
        return null;
      }

      const state = target.status.state || target.status || {};

      return {
        state,
        stateText: this.resolveStateText(state),
        timeStamp: target.status.timeStamp || target.status.updatedAt || target.status.createdAt || null,
        person: target.person,
        source: 'assessment'
      };
    },

    resolveStatusInfo(history) {
      const assessmentStatusInfo = this.resolveAssessmentStatusInfo(history);
      if (assessmentStatusInfo) {
        return assessmentStatusInfo;
      }

      const rawStatus = (history || {}).status;

      if (Array.isArray(rawStatus)) {
        const latestStatus = rawStatus.filter((entry) => entry && entry.state).at(-1);

        if (latestStatus) {
          const state = latestStatus.state || {};
          return {
            state,
            stateText: this.resolveStateText(state),
            timeStamp: latestStatus.timeStamp || latestStatus.updatedAt || latestStatus.createdAt || null,
            person: null,
            source: 'idp'
          };
        }

        const state = this.createStateFromLocalizedStatus(rawStatus);
        return {
          state,
          stateText: this.resolveStateText(state),
          timeStamp: (history || {}).timeStamp || (history || {}).updatedAt || (history || {}).dateTime || null,
          person: this.resolveHistoryAssessorName(history),
          source: 'assessment'
        };
      }

      if (rawStatus && rawStatus.state) {
        const state = rawStatus.state || {};
        return {
          state,
          stateText: this.resolveStateText(state),
          timeStamp: rawStatus.timeStamp || rawStatus.updatedAt || rawStatus.createdAt || null,
          person: null,
          source: 'assessment'
        };
      }

      return {
        state: {},
        stateText: '-',
        timeStamp: null,
        person: null,
        source: 'idp'
      };
    },

    buildItems(histories) {
      this.items = (Array.isArray(histories) ? histories : []).map((history) => {
        const statusInfo = this.resolveStatusInfo(history);
        const accounts = this.resolveHistoryAccountName(history);
        const assessor = this.resolveHistoryAssessorName(history);

        return {
          ...history,
          id: history._id,
          code: (((history || {}).accounts || {}).accounts || {}).code || '-',
          accounts,
          employmentStatus: this.resolveLocalizedValue((((((history || {}).accounts || {}).positions || []).at(-1) || {}).status || {}).title) || '-',
          assessor,
          state: statusInfo.stateText,
          status: statusInfo.state,
          latestStatusTime: statusInfo.timeStamp,
          statusPerson: statusInfo.person,
          statusSource: statusInfo.source,
        };
      });
    },
    elapsedTime(dateTime) {
      if (!dateTime) {
        return '-';
      }

      const now = moment();
      const past = moment(dateTime);

      if (!past.isValid()) {
        return '-';
      }

      const duration = moment.duration(now.diff(past));
      const minutes = duration.asMinutes();
      const hours = duration.asHours();

      if (minutes < 1) {
        return this.lang === 'th' ? 'เมื่อสักครู่นี้' : 'Just now';
      } else if (minutes < 60) {
        return `${Math.floor(minutes)} ${this.lang === 'th' ? 'นาทีที่แล้ว' : 'm ago'}`;
      } else if (hours < 24) {
        const h = Math.floor(hours);
        const m = Math.floor(minutes % 60);
        return `${h} ${this.lang === 'th' ? 'ชั่วโมง' : 'h'} ${m} ${this.lang === 'th' ? 'นาทีที่แล้ว' : 'm ago'}`;
      }

      return past.format('DD/MM/YYYY HH:mm');
    },
    isColor(item) {
      const stateId = item && item._id ? item._id.toString() : '';
      const stateMap = {
        '654851a37ab25be71bbeeed7': 'text-success',
        '654851dbe41b7f46025977f6': 'text-warning',
        '654851ece41b7f46025977fa': 'text-info',
        '670f777373effdb76e17954d': '',
        '6723709ab9a2030e40d1b884': 'text-danger',
        '67bc20d5ef3c015b73cf6dbc': 'text-warning',
        '67bc35d9ac0179614e274a67': 'text-warning',
        '67bfc7e724e13ba338b58e47': 'text-info',
        '67bfc7ed24e13ba338b58e4d': 'text-success'
      };

      return stateMap[stateId] || '';
    },
    onCheckState(item) {
      const status = item && item.status && item.status._id ? item.status._id.toString() : '';

      if ((item || {}).statusPerson && (item || {}).statusPerson !== '-') {
        return ` : ${item.statusPerson}`;
      }

      const stateToPersonMap = {
        '654851a37ab25be71bbeeed6': item.accounts,
        '654851dbe41b7f46025977f6': item.accounts,
        '654851ece41b7f46025977fa': item.assessor,
        '6723709ab9a2030e40d1b884': item.accounts,
        '67bc20d5ef3c015b73cf6dbc': item.assessor,
        '670f777373effdb76e17954d': item.accounts,
        '67bc2105ef3c015b73cf6dc2': item.accounts,
        '67bc2111ef3c015b73cf6dc8': item.accounts,
        '67bc35d9ac0179614e274a67': item.accounts,
        '67bfc7e724e13ba338b58e47': item.assessor
      };

      const person = stateToPersonMap[status];
      return person && person !== '-' ? ` : ${person}` : '';
    },
    buildExportRows() {
      return this.items.map((entry, index) => ({
        index: index + 1,
        code: entry.code || "-",
        name: entry.accounts || "-",
        employmentStatus: entry.employmentStatus || "-",
        assessor: entry.assessor || "-",
        status: entry.state || "-"
      }));
    },
    exportAll() {
      const workbook = XLSX.utils.book_new();
      const summarySheet = XLSX.utils.json_to_sheet(this.buildExportRows());

      XLSX.utils.book_append_sheet(workbook, summarySheet, "MemberStatus");
      XLSX.writeFile(workbook, `idp-member-status-${this.year || "report"}.xlsx`);
    }
  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
      reportMembers: "report/members",
    }),
    sourceItems() {
      return Array.isArray(this.item) ? this.item : this.reportMembers;
    }
  },

  watch: {
    lang() {
      this.buildItems(this.sourceItems);
    },
    sourceItems: {
      immediate: true,
      handler(value) {
        this.buildItems(value);
      }
    }
  }
}
</script>
<style>

.w50 {
  min-width: 50%;
}

.export-icon-button {
  align-items: center;
  background: #2f9bff;
  border-color: #2f9bff;
  border-radius: 50%;
  box-shadow: 0 8px 18px rgba(47, 155, 255, 0.28);
  color: #fff;
  display: inline-flex;
  height: 36px;
  justify-content: center;
  padding: 0;
  width: 36px;
}

.export-icon-button:hover,
.export-icon-button:focus {
  background: #168af0;
  border-color: #168af0;
  color: #fff;
}

.export-icon-button:disabled {
  background: #8ecaff;
  border-color: #8ecaff;
  box-shadow: none;
  color: rgba(255, 255, 255, 0.78);
}

.input-group-append .form-group {
  margin-bottom: 0px;
}

.text-right {
  text-align: end;
}

.bg-login1 {
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #a54af0 0%, #539cf8 60%, #C8CED3 80%);
}
</style>
